import { SRFBridge } from 'srf-native-bridge';

// fixes touch-states in webviews. Details: https://css-tricks.com/snippets/css/remove-gray-highlight-when-tapping-links-in-mobile-safari/
if (SRFBridge.isRunningInApp()) {
  document.addEventListener('touchstart', function () {}, true);
}
